import { ProcedimentoDTO } from "./procedimentoDTO";

export class IstanzaAttivitaDTO {
  id: string;

  nome: string;

  codice: string;

  procedimentiAssociati: ProcedimentoDTO[];
}
